import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <a
        href="https://github.com/RenaLo/weather-app-react"
        target="_blank"
        rel="noreferrer"
        className="Link"
      >
        Open-source code{" "}
      </a>
      by Verena Lo
    </div>
  );
}
